module.exports = __webpack_public_path__ + "img/logo.52539a58.png";